import axios from "../../axios/axios-censo";

export const pegaUltimasInternacoes = ({ commit }, payload) => {
    let config = {
        params: {
          cnes: payload
        }
    }
    
    return axios
    .get("listarUltimasInteracoes.php", config)
    .then(resp => {
        if (resp.data.status == true) commit("setUltimasInternacoes", resp.data)
    })
    .catch(error => {
        console.log(error)
    });

};
